<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Sale Order Creation</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    <div class="col-md-6">
<!--------------------------------------------------------------------------------->
<div class="form-group">

    <div class="form-group">
        <label>Select Customer</label><span class="error">{{NoCustomer}}</span>
        <div class="input-group">
        <input type="search"  [readonly]="isAddProduct" class="form-control form-control-lg" placeholder="Search customer" [(ngModel)]="data.c_name" (ngModelChange)="SearchCustomer()">
        <button type="submit" class="btn btn-lg btn-default" (click)="SearchCustomer();">
        <i class="fa fa-search"></i>
        </button>

        </div>

        <div class="card card-default"  *ngIf="isShownCustomer">
            <div *ngFor="let c of customers" >
            <h4 class="font" (click)="getCustomerId(c)"><b>{{c.customer_name}}</b></h4>
            </div>
            </div>
    
    </div>
    
    </div>
    <!---------------------------------------------------------------->

    <div class="form-group">
        <label>Customer Contract</label>
        <input type="text"  [readonly]="true" class="form-control size" [(ngModel)]="body.contract">
    </div>
    
    <!----------------------------------------------------------------->

    <div class="form-group">
        <button class="left1"  mat-raised-button  >
            <span class="mdc-button__label colr" (click)="AddProduct()" >SELECT PRODUCTS</span>
        </button>
     
    </div>
<!------------------enter card here---------------------------------->
 <!-----------------add products----------------->
    
 <div class="card card-success" *ngIf="isAddProduct">
       
    <form>
    <div class="card-body">
<!----------------------------------------------------------------------------->
<div class="form-group">
    
    <label>Search Product</label><span class="error">{{NoProduct}}</span>
 
<div class="input-group">
    <input type="search" class="form-control form-control-lg"  name="product" placeholder="Search product" [(ngModel)]="data.p_name" (ngModelChange)="SearchProduct();SetProduct($event)">
    <button type="submit" class="btn btn-lg btn-default" (click)="SearchProduct();">
    <i class="fa fa-search"></i>
    </button>

    </div>

    <div class="card card-default"  *ngIf="isShownProduct">
        <div *ngFor="let c of products" >
        <h4 class="font" (click)="getProductId(c)"><b>{{c.product_name}}</b></h4>
        </div>
        </div>

</div>
   
        
<!-------------------------------------------------------------------------------->  

<div class="form-group">
<label for="exampleInputPassword1">Brand Name</label>
<input type="text" [readonly]="true" class="form-control" name="BrandName" [(ngModel)]="data.b_name">
</div>
<!-------------------
<div class="form-group">
<label for="exampleInputPassword1">Category Name</label>
<input type="text" [readonly]="true" class="form-control" name="CategoryName" [(ngModel)]="data.cat_name">
</div>
-------------------------->
<div class="form-group">
<label for="exampleInputPassword1">Unit Price</label>
<input type="number" [readonly]="true" class="form-control" name="SupplierName" [(ngModel)]="data.price">
</div>

<div class="form-group">
<label for="exampleInputPassword1">Select Quantity</label><span class="error">{{NoQuentity}}</span>
<input type="number" class="form-control" name="quentity" [(ngModel)]="data.quantity" (ngModelChange)="SetValue($event)">
</div>
</div>

   <div class="card-footer">
   <button class="left_B"  mat-raised-button >
   <span class="mdc-button__label colr" (click)="AddOne();">ADD</span>
   </button>
   </div>

    </form>
    </div>
</div>
    
    <!---------------------------------------------next row-------------------------------------->
    <div class="col-md-6">
<!--------------------------------->
        <div class="form-group">
            <label>Customer Id</label>
            <input type="text"  [readonly]="true" class="form-control size" [(ngModel)]="data.company_id">
        </div>

        <div class="form-group">
            <label>Customer Code</label>
            <input type="text"  [readonly]="true" class="form-control size" [(ngModel)]="body.customer_code">
        </div>
<!-------------------------------------->
        <div class="form-group">
            <label *ngIf="isItemselected" class="Top">Items Selected</label>
           
            <div class="card" *ngIf="isItemselected">
               <!-------------------table inside the class------------------->
               <table class="table table-striped">
                <thead>
                <tr>
                <th style="width: 38%">Product</th>
                <th>Qty</th>
                <th>Unit Price</th>
                <th>Subtotal</th>
                <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let c of order">
                <td>{{c.item_name}}</td>
                <td><input type="number" class="TextSize" value="{{c.quantity}}" [(ngModel)]="c.quantity" (ngModelChange)="c.quantity=$event;c.amount=SetTotal($event,c.unit_price);">
                <td>{{c.unit_price}}</td>
                 <td>{{c.amount}}</td>
                <td class="project-actions text-right">
                <a class="btn btn-danger btn-sm" data-toggle="modal" data-target="#modal-sm" (click)="delete(c.val);">
                <i class="fas fa-trash">
                </i>
                Delete
                </a>
                </td>
                </tr>

                </tbody>
                </table>

        <!-------------------Test alert---------------------->
        <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isChange">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
            <h4><i class="icon fas fa-check"></i> {{alert}}</h4>
             
            </div>
       

                <button class="left_C"  mat-raised-button >
                    <span class="mdc-button__label colr" (click)="PlaceOrder();">Place Your Order</span>
                </button>
                <br>

               <!----------------------------------------------------------->
            </div>
        </div>

        
    </div>
   

    <!---------------------------------------------------------------------->     


<!------------------------------------------------------------------>

